/**
 * Logs API functions for operation audit trail.
 */

import apiClient from './client';
import type { OperationLog } from '@/types';

export interface LogsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: OperationLog[];
}

export interface LogsParams {
  page?: number;
  page_size?: number;
  entity_type?: string;
  entity_id?: string;
  action?: string;
  operator_id?: string;
  date_from?: string;
  date_to?: string;
}

/**
 * Get operation logs with optional filters.
 */
export const getLogs = async (params?: LogsParams): Promise<LogsResponse> => {
  const response = await apiClient.get<LogsResponse>('/logs/', { params });
  return response.data;
};

/**
 * Get operation logs for a specific package.
 */
export const getPackageLogs = async (
  packageId: number,
  params?: { page?: number; page_size?: number }
): Promise<LogsResponse> => {
  const response = await apiClient.get<LogsResponse>(
    `/packages/${packageId}/logs/`,
    { params }
  );
  return response.data;
};

/**
 * Get a single log entry by ID.
 */
export const getLog = async (id: string): Promise<OperationLog> => {
  const response = await apiClient.get<OperationLog>(`/logs/${id}/`);
  return response.data;
};
